import { useState } from "react";

const BUILD_FULL = `v${__APP_VERSION__} · ${__GIT_SHA__}`;
const BUILD_SHORT = new Date(__BUILD_TIME__).toLocaleString(undefined, {
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  month: "short",
});

function getBadgeText(copied: boolean, hovered: boolean) {
  if (copied) {
    return "copied!";
  }
  if (hovered) {
    return BUILD_FULL;
  }
  return BUILD_SHORT;
}

export function BuildBadge() {
  const [hovered, setHovered] = useState(false);
  const [copied, setCopied] = useState(false);

  function handleClick() {
    void navigator.clipboard.writeText(BUILD_FULL).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    });
  }

  return (
    <span
      className={`build-badge${hovered ? " build-badge--expanded" : ""}`}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      onClick={handleClick}
    >
      {getBadgeText(copied, hovered)}
    </span>
  );
}
